import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import putUploadAjax from '@/util/putUploadAjax';
import { uploadFn } from 'api/common';
export default {
  props: {
    actionUrl: {
      // 上传地址
      type: String,
      default: '/app/tool/upload_url'
    },
    data: {
      // 上传时需要携带的参数
      type: Object
    },
    fileFormat: {
      // 上传文件的格式 为空则可上传所有文件类型
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fileSize: {
      // 上传文件时，单个文件的大小 单位是 M（兆）
      type: Number,
      default: 5
    },
    fileLimit: {
      // 上传文件的个数
      type: Number,
      default: 2
    },
    content: {
      default: ''
    },
    maxDisplayNum: {
      default: 10
    },
    showFile: {
      default: true
    },
    showBtn: {
      default: true
    },
    disabled: {
      default: false
    }
  },
  data: function data() {
    return {
      uploadUrl: '',
      multiple: true,
      uploadHeaders: {},
      successFileList: []
    };
  },
  methods: {
    init: function init() {
      this.visible = true;
    },
    putUploadAjax: putUploadAjax,
    beforeUploadHandle: function beforeUploadHandle(file) {
      var _this = this;
      //  文件扩展名
      if (this.fileFormat.length) {
        var fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(this.$t('729', {
            fileFormat: this.fileFormat.join()
          }));
          return false;
        }
      } else {
        // this.listType = "text";
      }

      // 文件大小
      if (!(file.size / 1024 / 1024 < this.fileSize)) {
        this.$message.error(this.$t('730', {
          fileSize: this.fileSize
        }));
        return false;
      }
      return new Promise(function (resolve, reject) {
        uploadFn(_this.actionUrl, _objectSpread(_objectSpread({}, _this.data), {}, {
          file_name: file.name,
          bucket_name: 'file'
        })).then(function (data) {
          file.prepareData = data.data;
          _this.uploadUrl = data.data.put_url;
          _this.uploadHeaders['Content-Type'] = data.data.content_type;
          resolve(file);
        }).catch(function () {
          _this.$message.error('retry later please');
          reject(file);
        });
      });
    },
    progressHandle: function progressHandle() {},
    // 上传成功+
    successHandle: function successHandle(res, file) {
      this.successFileList.push({
        file_name: file.name,
        object_key: file.raw.prepareData.object_key,
        object_url: file.raw.prepareData.object_url
      });
      this.reset();
    },
    // 更新
    reset: function reset() {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.$emit('success', _this2.successFileList);
      });
    },
    // 上传失败
    // err, file, fileList
    errorHandle: function errorHandle(err, file) {
      var index = this.$refs.upload.uploadFiles.findIndex(function (v) {
        return v.name === file.name;
      });
      this.$refs.upload.uploadFiles.splice(index, 1);
      this.$message.error('upload error');
      throw err;
    },
    exceedHandle: function exceedHandle() {
      this.$message.error(this.$t('731', {
        fileLimit: this.fileLimit
      }));
    },
    handleOpen: function handleOpen(e) {
      e.stopPropagation();
    },
    // 删除
    handleRemove: function handleRemove(e, item) {
      var _this3 = this;
      e.stopPropagation();
      this.$confirm(this.$t('732'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        confirmButtonClass: 'el-button--mini',
        cancelButtonClass: 'el-button--mini',
        type: 'warning'
      }).then(function () {
        _this3.successFileList.splice(_this3.successFileList.findIndex(function (v) {
          return v.object_url === item.object_url;
        }), 1);
        _this3.$refs.upload.uploadFiles.splice(_this3.$refs.upload.uploadFiles.findIndex(function (v) {
          return v.name === item.file_name;
        }), 1);
        _this3.reset();
      });
    }
  }
};